// @flow
import React from 'react'

const Lock = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 -3 16 16">
      <g fill="none" fillRule="evenodd">
        <path d="M-1-3h16v16H-1z" />
        <path
          fill="#082622"
          fillRule="nonzero"
          d="M7-3C4.8-3 3-1.2 3 1v1H1c-.6 0-1 .4-1 1v9c0 .6.4 1 1 1h12c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1h-2V1c0-2.2-1.8-4-4-4zM8 8.7V10H6V8.7c-.6-.3-1-1-1-1.7 0-1.1.9-2 2-2s2 .9 2 2c0 .7-.4 1.4-1 1.7zM9 2H5V1c0-1.1.9-2 2-2s2 .9 2 2v1z"
        />
      </g>
    </svg>
  )
}

export default Lock



// WEBPACK FOOTER //
// ./src/components/Icons/Lock.js